import { createSelector } from "@ngrx/store";

import * as fromFeature from "../reducers";

export const getAllControllers = createSelector(fromFeature.getGibState, (state: fromFeature.GibState) => state.tkControllerState.tkControllers);
